<template>
  <el-dropdown size="small" :class="{'d2-mr':device!== 'mobile'}">
    <span class="btn-text" :class="{'btn-text-mobile':device === 'mobile'}">{{ info.username ? `${$t("Hello")} ${info.username}` : "Not logged in" }}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="handleModifyPassword">
        <d2-icon name="edit" class="d2-mr-5" />
        {{ $t("modifyPassword") }}
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" />
        {{ $t("logout") }}
      </el-dropdown-item>
    </el-dropdown-menu>
    <ModifyPassword ref="modifyPassword" :type="1" @success="handleModifySuccess"></ModifyPassword>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModifyPassword from "@/components/modifyPassword";
export default {
  components: { ModifyPassword },
  computed: {
    ...mapState('d2admin', {
      info: state => state.user.info,
      device: state => state.app.device
    })
  },
  methods: {
    ...mapActions("d2admin/account", ["logout"]),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        confirm: true,
      });
    },
    handleModifyPassword() {
      this.$refs.modifyPassword.show({});
    },
    handleModifySuccess() {
      this.logout({
        confirm: false,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-text {
  padding: 1rem 2rem !important;
  border-left: 2px solid #ddd;
  border-radius: 0px !important;
}
.btn-text-mobile {
  padding: 1rem 0.5rem !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
